import type { RouteRecordRaw } from 'vue-router';
import { batstoolRoutes } from '@/router/batstool';

export type RoleRouteConfig = RouteRecordRaw & { roles?: string[] };

export const routes: Array<RoleRouteConfig> = [
  { path: '/', redirect: '/home/' },
  {
    path: '/home/',
    name: 'home',
    component: () => import('@/views/Home'),
    meta: {
      title: 'BATstool'
    }
  },
  ...batstoolRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'page-404',
    component: () => import('@/views/Page404View'),
    meta: {
      title: 'Page Not Found'
    }
  }
];
